// Helpers de fuso (SC/Floripa = America/Sao_Paulo)
import { format, parseISO } from 'date-fns';
import { formatInTimeZone, toZonedTime } from 'date-fns-tz';
import { ptBR } from 'date-fns/locale';

export const TZ = 'America/Sao_Paulo';

export function formatHoraSC(iso) {
  if (!iso) return '-';
  return formatInTimeZone(parseISO(iso), TZ, 'HH:mm');
}
export function formatDataHoraSC(iso) {
  if (!iso) return '-';
  return formatInTimeZone(parseISO(iso), TZ, 'dd/MM HH:mm', { locale: ptBR });
}
export function formatDataSC(iso) {
  if (!iso) return '-';
  return formatInTimeZone(parseISO(iso), TZ, 'dd/MM/yyyy', { locale: ptBR });
}
export function hojeSC() {
  return formatInTimeZone(new Date(), TZ, 'yyyy-MM-dd');
}
export function dataParaInput(date) {
  return formatInTimeZone(date, TZ, 'yyyy-MM-dd');
}
